import { createSlice } from '@reduxjs/toolkit';
import { createCommand, deleteCommand, fetchCommands, updateCommand } from './command.actions';

const initialState = {
  commands: [],
  metaData: { total: 0, page: 1, perPage: 10 },

  isLoadingCreateCommand: false,
  isLoadingFetchCommands: false,
  isLoadingUpdateCommand: false,
  isLoadingDeleteCommand: false
};

const commandSlice = createSlice({
  name: 'command',
  initialState,
  reducers: {
    clearCommandState: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(createCommand.pending, (state) => {
      state.isLoadingCreateCommand = true;
    });
    builder.addCase(createCommand.fulfilled, (state) => {
      state.isLoadingCreateCommand = false;
    });
    builder.addCase(createCommand.rejected, (state) => {
      state.isLoadingCreateCommand = false;
    });

    builder.addCase(fetchCommands.pending, (state) => {
      state.isLoadingFetchCommands = true;
    });
    builder.addCase(fetchCommands.fulfilled, (state, action) => {
      state.commands = action.payload.data;
      state.metaData = action.payload.metaData;
      state.isLoadingFetchCommands = false;
    });
    builder.addCase(fetchCommands.rejected, (state) => {
      state.isLoadingFetchCommands = false;
    });

    builder.addCase(updateCommand.pending, (state) => {
      state.isLoadingUpdateCommand = true;
    });
    builder.addCase(updateCommand.fulfilled, (state) => {
      state.isLoadingUpdateCommand = false;
    });
    builder.addCase(updateCommand.rejected, (state) => {
      state.isLoadingUpdateCommand = false;
    });

    builder.addCase(deleteCommand.pending, (state) => {
      state.isLoadingDeleteCommand = true;
    });
    builder.addCase(deleteCommand.fulfilled, (state) => {
      state.isLoadingDeleteCommand = false;
    });
    builder.addCase(deleteCommand.rejected, (state) => {
      state.isLoadingDeleteCommand = false;
    });
  }
});

export const { clearCommandState } = commandSlice.actions;

export default commandSlice.reducer;
